module.exports = __webpack_public_path__ + "static/img/334.1657185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/334.jpg
// module id = 8R4y
// module chunks = 0